// src/admin/AdminCitiesPage.js
import React, { useState, useEffect } from 'react';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  GeoPoint,
} from 'firebase/firestore';
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { db, storage } from '../firebase';

import AdminJourneyCities from './AdminJourneyCities';

// Country list - you can expand this or import from a package
const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CV', name: 'Cape Verde' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Congo' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Greece' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'North Korea' },
  { code: 'KR', name: 'South Korea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Mexico' },
  { code: 'FM', name: 'Micronesia' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russia' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'KN', name: 'Saint Kitts and Nevis' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Sao Tome and Principe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syria' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatican City' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
];

const toNumber = (coord, axis) => {
  if (coord == null || coord === '') return '';
  if (typeof coord === 'number' || typeof coord === 'string') return coord;
  if (typeof coord.latitude === 'number') {
    return axis === 'lat' ? coord.latitude : coord.longitude;
  }
  return '';
};

function AdminCitiesPage() {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState({
    id: '',
    name: '',
    country: '',
    countryCode: '',
    notes: '',
    iataCode: '',
    latitude: '',
    longitude: '',
    images: [],
    description: '',
    coverImage: '',
    cityVibes: '',
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  /* ─────────── Fetch ─────────── */
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const cSnap = await getDocs(collection(db, 'cities'));
        if (!isMounted) return;
        setCities(
          cSnap.docs.map((d) => ({
            ...d.data(),
            id: d.id,
            latitude: toNumber(d.data().latitude ?? d.data().coordinates, 'lat'),
            longitude: toNumber(d.data().longitude ?? d.data().coordinates, 'lng'),
            images: d.data().images || [],
            country: d.data().country || '',
            countryCode: d.data().countryCode || '',
            description: d.data().description || '',
            coverImage: d.data().coverImage || '',
          }))
        );
      } catch (err) {
        console.error(err);
        setError('Failed to load data');
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  /* ─────────── Basic handlers ─────────── */
  const handleCityInputChange = (e) => {
    const { name, value } = e.target;
    
    // If country dropdown changed, update both country name and code
    if (name === 'countryCode') {
      const selectedCountry = COUNTRIES.find(c => c.code === value);
      setSelectedCity((p) => ({ 
        ...p, 
        countryCode: value,
        country: selectedCountry ? selectedCountry.name : ''
      }));
    } else {
      setSelectedCity((p) => ({ ...p, [name]: value }));
    }
  };
  
  const handleEditCity = (city) =>
    setSelectedCity({
      ...city,
      latitude: toNumber(city.latitude ?? city.coordinates, 'lat'),
      longitude: toNumber(city.longitude ?? city.coordinates, 'lng'),
      country: city.country || '',
      countryCode: city.countryCode || '',
      description: city.description || '',
      coverImage: city.coverImage || '',
      cityVibes: city.cityVibes || '',
    });

  /* ─────────── CRUD ─────────── */
  const handleSaveCityChanges = async (override) => {
    try {
      const data = override ? { ...override } : { ...selectedCity };
      const lat = parseFloat(data.latitude);
      const lng = parseFloat(data.longitude);
      if (!isNaN(lat) && !isNaN(lng)) {
        data.coordinates = new GeoPoint(lat, lng);
        data.latitude = lat;
        data.longitude = lng;
      }

      if (!data.id) {
        const docRef = await addDoc(collection(db, 'cities'), data);
        data.id = docRef.id; // so upload can use it
      } else {
        await updateDoc(doc(db, 'cities', data.id), data);
      }

      /* refresh list */
      const snap = await getDocs(collection(db, 'cities'));
      setCities(
        snap.docs.map((d) => ({
          ...d.data(),
          id: d.id,
          latitude: toNumber(d.data().latitude ?? d.data().coordinates, 'lat'),
          longitude: toNumber(d.data().longitude ?? d.data().coordinates, 'lng'),
          images: d.data().images || [],
          country: d.data().country || '',
          countryCode: d.data().countryCode || '',
          description: d.data().description || '',
          coverImage: d.data().coverImage || '',
        }))
      );

      setSelectedCity({
        id: '',
        name: '',
        country: '',
        countryCode: '',
        notes: '',
        iataCode: '',
        latitude: '',
        longitude: '',
        images: [],
        description: '',
        coverImage: '',
      });
    } catch (err) {
      console.error(err);
      setError('Failed to save city');
    }
  };

  const handleDeleteCity = async (id) => {
    if (!window.confirm('Delete this city?')) return;
    try {
      await deleteDoc(doc(db, 'cities', id));
      /* Optionally delete images in Storage here */
      setCities((p) => p.filter((c) => c.id !== id));
    } catch (err) {
      console.error(err);
      setError('Failed to delete city');
    }
  };

  /* ─────────── IMAGE UPLOAD / DELETE ─────────── */
  const uploadTask = (cityId, file, isCover = false) => {
    const folder = isCover ? 'cityCoverImages' : 'cityImages';
    const path = `${folder}/${cityId}/${file.name}`;
    const storageRef = ref(storage, path);
    return uploadBytesResumable(storageRef, file);
  };

  const handleUploadCityImage = async (file) => {
    if (!selectedCity.id) throw new Error('City ID missing.');
    const task = uploadTask(selectedCity.id, file);

    await new Promise((res, rej) => {
      task.on(
        'state_changed',
        null,
        (e) => rej(e),
        () => res()
      );
    });
    return await getDownloadURL(task.snapshot.ref);
  };

  const handleUploadCoverImage = async (file) => {
    if (!selectedCity.id) throw new Error('City ID missing.');
    const task = uploadTask(selectedCity.id, file, true);

    await new Promise((res, rej) => {
      task.on(
        'state_changed',
        null,
        (e) => rej(e),
        () => res()
      );
    });
    return await getDownloadURL(task.snapshot.ref);
  };

  const handleDeleteCityImage = async (cityId, url) => {
    const storageRef = ref(storage, url);
    await deleteObject(storageRef);
    /* Remove from Firestore */
    const docRef = doc(db, 'cities', cityId);
    const cityDoc = cities.find((c) => c.id === cityId);
    if (!cityDoc) return;
    const newImgs = (cityDoc.images || []).filter((u) => u !== url);
    await updateDoc(docRef, { images: newImgs });
    setCities((p) =>
      p.map((c) => (c.id === cityId ? { ...c, images: newImgs } : c))
    );
  };

  const handleDeleteCoverImage = async (cityId) => {
    const cityDoc = cities.find((c) => c.id === cityId);
    if (!cityDoc || !cityDoc.coverImage) return;

    try {
      const storageRef = ref(storage, cityDoc.coverImage);
      await deleteObject(storageRef);
    } catch (err) {
      console.error('Error deleting cover image from storage:', err);
    }

    /* Remove from Firestore */
    const docRef = doc(db, 'cities', cityId);
    await updateDoc(docRef, { coverImage: '' });
    setCities((p) =>
      p.map((c) => (c.id === cityId ? { ...c, coverImage: '' } : c))
    );
    setSelectedCity((p) => ({ ...p, coverImage: '' }));
  };

  /* ─────────── Other helpers ─────────── */

  if (loading) return <div>Loading Cities…</div>;

  return (
    <div>
      <h2>Manage Cities</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <AdminJourneyCities
        cities={cities}
        selectedCity={selectedCity}
        countries={COUNTRIES}
        handleCityInputChange={handleCityInputChange}
        handleEditCity={handleEditCity}
        handleDeleteCity={handleDeleteCity}
        handleSaveCityChanges={handleSaveCityChanges}
        handleUploadCityImage={handleUploadCityImage}
        handleDeleteCityImage={handleDeleteCityImage}
        handleUploadCoverImage={handleUploadCoverImage}
        handleDeleteCoverImage={handleDeleteCoverImage}
        setSelectedCity={setSelectedCity}
      />
    </div>
  );
}

export default AdminCitiesPage;